import { render } from "./CourseType.vue?vue&type=template&id=0f3782c8"
import script from "./CourseType.vue?vue&type=script&lang=ts"
export * from "./CourseType.vue?vue&type=script&lang=ts"
script.render = render

export default script